import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { ibanVerificationService } from '../../../api/ibanVerification';
import { PaginatedRequest } from '../../../types/api';
import { ApproveIbanVerificationRequest, RejectIbanVerificationRequest } from '../../../types/ibanVerifications';

export const fetchIbanVerifications = createAsyncThunk('ibanVerification/fetch-all', (data: PaginatedRequest) =>
  ibanVerificationService.fetchIbanVerifications(data),
);

export const fetchIbanVerification = createAsyncThunk('ibanVerification/get', (id: number) =>
  ibanVerificationService.fetchIbanVerification(id),
);

export const approveIbanVerification = createAsyncThunk(
  'ibanVerification/approve',
  (data: ApproveIbanVerificationRequest) => ibanVerificationService.approveIbanVerification(data),
);

export const rejectIbanVerification = createAsyncThunk(
  'ibanVerification/reject',
  (data: RejectIbanVerificationRequest) => ibanVerificationService.rejectIbanVerification(data),
);

export const cleanIbanVerifications = createAction('ibanVerification/clean');

export const resetEditIbanVerification = createAction('ibanVerification/reset-edit');
